// Copyright 2025, University of Maryland, All Rights Reserved
import { useState } from 'react'
import type { APISession } from '@/types/session'

const API_SESSIONS: APISession[] = ['2023RS', '2024RS', '2025RS', '2026RS']
const DATA_SOURCES = ['Maryland', 'Federal'] as const
export type DataSource = typeof DATA_SOURCES[number]

export function useDatasourceState() {
  const [selectedDataSource, setSelectedDataSource] = useState<DataSource>('Maryland')
  const [isSyncSettingsExpanded, setIsSyncSettingsExpanded] = useState(false)
  const [expandedSessions, setExpandedSessions] = useState<Record<string, boolean>>({})

  const toggleSessionExpanded = (session: string) => {
    setExpandedSessions(prev => ({
      ...prev,
      [session]: !prev[session]
    }))
  }

  return {
    selectedDataSource,
    setSelectedDataSource,
    isSyncSettingsExpanded,
    setIsSyncSettingsExpanded,
    expandedSessions,
    toggleSessionExpanded,
    API_SESSIONS,
    DATA_SOURCES
  }
}
